<!-- services page section  -->
<div class="sevices-herobanner">
  <div class="container">
    <div class="row service-banner-container">
      <div class="col-md-7 order-mobile-2">
        <h5 class="banner-title">
          Qualibar - Leader in TaaS 
          <br>(Testing as a Service)
        </h5>
        <h6 class="banner-subtitle">
          A one-stop shop for all your testing needs.
        </h6>
      </div>
      <div class="col-md-5 order-mobile-1 text-center">
        <img src="./assets/images/services/banner-img.svg" alt="" class="banner-img">
      </div>
    </div>
  </div>
</div>

<!-- services section  -->
<div class="mt-0 service-odd" id="services">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center mb-5">
        <h6 class="title-primary">
          QA Services
        </h6>
        <h6 class="service-subtitle">
          30% Increase in Speed-to-Market with our QA Testing Services
        </h6>
        <p class="service-description">
          Qualibar provides QA software testing services to validate different functions of your application, all managed in our top-notch testing labs. Our certified testing team can ensure faster time-to-market for your software products with the deployment of automated regression test suites.
        </p>
      </div>
      <div class="service-list-container mt-2 pb-3 mb-0">
        <div class="service-list-card mobiel-testing-card" (click)="navigateToSection('mobiletesting')">
          <img src="./assets/images/services/mobileapp-testing.svg" alt="" class="service-img">
          <h6 class="service-name">Mobile App Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card browser-testing-card" (click)="navigateToSection('browsertesting')">
          <img src="./assets/images/services/crossbrowser-testing.svg" alt="" class="service-img">
          <h6 class="service-name">Browser Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card api-testing-card" (click)="navigateToSection('apitesting')">
          <img src="./assets/images/services/api-testing.svg" alt="" class="service-img">
          <h6 class="service-name">API Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card ott-testing-card" (click)="navigateToSection('otttesting')">
          <img src="./assets/images/services/otttesting.svg" alt="" class="service-img">
          <h6 class="service-name">OTT Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card iot-testing-card" (click)="navigateToSection('iottesting')">
          <img src="./assets/images/services/iottesting.svg" alt="" class="service-img">
          <h6 class="service-name">IOT Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card ai-testing-card" (click)="navigateToSection('aitesting')">
          <img src="./assets/images/services/AI-testing.svg" alt="" class="service-img">
          <h6 class="service-name">AI & ML Intelligent Test Automation</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card mobiel-testing-card" (click)="navigateToSection('performancetesting')">
          <img src="./assets/images/services/performance-testing.svg" alt="" class="service-img">
          <h6 class="service-name">Performance Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card dataint-testing-card" (click)="navigateToSection('datatesting')">
          <img src="./assets/images/services/dataintegrity-testing.svg" alt="" class="service-img">
          <h6 class="service-name">Data Integrity Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card box-testing-card" (click)="navigateToSection('boxtesting')">
          <img src="./assets/images/services/boxtesting.svg" alt="" class="service-img">
          <h6 class="service-name">Black Box & White Box Testing</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
        <div class="service-list-card automation-testing-card" (click)="navigateToSection('automationtesting')">
          <img src="./assets/images/services/testing-automation.svg" alt="" class="service-img">
          <h6 class="service-name" style="white-space: nowrap;">Testing Automation <br> (CI/CD Integration)</h6>
          <ul class="service-keylist">
            <li>User Experience Testing</li>
            <li>Usability Testing</li>
            <li>Security Testing</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobile app testing  -->
<div class="service-even" id="mobiletesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">Mobile App Testing</h6>
        <p class="service-description">
          Our Mobile App testing service lets you test your app through a broad range of devices including iPhone, iPad, Samsung Galaxy, One Plus, Google Pixel, Motorola, and Nokia, across screen size, resolution, and OS (ranging from Android 4.4 to 11 and iOS 8 to 14). Qualibar provides various device features like GPS, network simulation, and localization to recreate real-world situations for in-depth app testing. And the list keeps increasing.
        </p>
        <h6 class="service-subtitle">Our Mobile App Testing Process:</h6>
        <ul class="key-services row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">User Experience Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Usability Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Functional Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Security Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Performance Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Device and Platform Testing</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/mobileapp-testing.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>

<!-- Browser testing  -->
<div class="service-odd" id="browsertesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/crossbrowser-testing.svg" alt="" class="service-img">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">Browser Testing</h6>
        <p class="service-description">
          Qualibar offers a seamless browser testing experience for digital accuracy of your applications. Our Browser Testing service lets you remotely test and debug mobile, web, audio and video applications on n-number of devices of various screen sizes, resolutions, OS versions, and browser versions from around the globe while keeping the software development process swift, smooth and reliable.
        </p>
        <h6 class="service-subtitle">Our Browser Testing Process:</h6>
        <ul class="key-services odd-keyservices row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Determine Statistics</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Analyze Test Application</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Determine Testing Process</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Execute Test</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Record and Report</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- API testing  -->
<div class="service-even" id="apitesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">API Testing</h6>
        <p class="service-description">
          APIs are the connecting threads between different systems or layers of an application. It is one of the most important layers of an app as it holds the main business logic, the protocol for how users can communicate with services, data, or functions of the app. As a result, it becomes imperative that these APIs are tested thoroughly in order to avoid unwarranted errors. At Qualibar, we provide a broad range of top-grade API Testing services to ensure a highly powerful software application for your business.
        </p>
        <h6 class="service-subtitle">Our API Testing Services:</h6>
        <ul class="key-services row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Automated API Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Functionality Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Reliability Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Load Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Security Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Negative Testing</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/api-testing.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>

<!-- OTT Testing  -->
<div class="service-odd" id="otttesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/otttesting.svg" alt="" class="service-img">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">OTT Testing</h6>
        <p class="service-description">
          With the advent of direct-to-consumer models, conventional video service providers are switching to Over-The-Top (OTT) services. This immense shift requires thorough testing of OTT media service applications along with the related network components. Qualibar is here to provide you with advanced OTT Testing services, so you can guarantee impeccable content delivery and exceptional user experience.
        </p>
        <h6 class="service-subtitle">Our OTT Testing Process:</h6>
        <ul class="key-services odd-keyservices row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Understand Languages and Tools</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Understand Source Code</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Write Test Cases</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Execute Test Cases</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Analyze and Record Results</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- IOT Testing  -->
<div class="service-even" id="iottesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">IOT Testing</h6>
        <p class="service-description">
          The Internet of Things is transforming the way consumers are interacting with modern technology, making it extremely important for manufacturers to ensure seamless performance of their products, which in turn requires end-to-end testing of varied devices across platforms. Qualibar makes sure that your product is well received by consumers and performs glitch-free by testing every possible use case based on real-life scenarios.
        </p>
        <h6 class="service-subtitle">Our IOT Testing Process:</h6>
        <ul class="key-services row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Understand Languages and Tools</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Understand Source Code</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Write Test Cases</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Execute Test Cases</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Analyze and Record Results</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/iottesting.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>

<!-- AI AND ML INTELLIGENT TEST AUTOMATION  -->
<div class="service-odd" id="aitesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/AI-testing.svg" alt="" class="service-img">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">AI & ML intelligent test automation</h6>
        <p class="service-description">
          AI & ML technologies in the digital age demand innovative methods of software testing given their paradigm shifting nature. Utilizing these technologies requires organizations to have up-to-date security measures for business applications. At Qualibar, we assist companies with simplifying such complex processes by providing testing services.
        </p>
        <h6 class="service-subtitle">Our AI and ML Technologies:</h6>
        <ul class="key-services odd-keyservices row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Data Visualisation</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Feature Selection and Reduction</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Data Verification</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Natural Language Processing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Machine Learning</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Data Wrangling and Pre-Processing</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Performance Testing  -->
<div class="service-even" id="performancetesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">Performance Testing</h6>
        <p class="service-description">
          Qualibar guarantees the reliability, reactiveness and uninterrupted performance of your software products or critical applications, which are of utmost importance to the success of your business. We help you determine how your applications work under varying loads and find solutions to all of your existing bottlenecks. We offer a varied range of Performance Testing services spanning across multiple domains and platforms such as mobile, desktop, web, cloud and analytics.
        </p>
        <h6 class="service-subtitle">Our Performance Testing Services:</h6>
        <ul class="key-services row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Load Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Endurance Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Stress Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Scalability Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Spike Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Volume Testing</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/performance-testing.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>

<!-- Data Integrity Testing  -->
<div class="service-odd" id="datatesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/dataintegrity-testing.svg" alt="" class="service-img">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">Data Integrity Testing</h6>
        <p class="service-description">
          The current digital era demands high quality data that has the capacity of turning numbers into decisions. Qualibar provides unparalleled Data Integrity Testing services for your critical business operations by making sure that your data reaches you flawlessly, as it moves from a source to your destination systems.
        </p>
        <h6 class="service-subtitle">Our Data Integrity Testing Services:</h6>
        <ul class="key-services odd-keyservices row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">True End-to-End Data Testing</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Tailored Data Tests</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Model-Based Test Automation</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Risk-Based Prioritization</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Actionable Data Quality Reports</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">DataOps/DevOps Integration</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Black Box and White Box Testing  -->
<div class="service-even" id="boxtesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">Black Box & White Box Testing</h6>
        <p class="service-description">
          Qualibar provides an extra edge by enabling you and your developers to keep your code flawless and your functionalities under control, which will make your software fast, steady and secure. Our Black Box and White Box Testing services allow you to spot hidden and minute errors as well as detect unsteady responses and functional inconsistencies. Give your users a seamless experience by making sure your software works without a single glitch.
        </p>
        <h6 class="service-subtitle">Our Black Box & White Box Testing Process:</h6>
        <ul class="key-services row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Understand Languages and Tools</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Understand Source Code</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Write Test Cases</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Execute Test Cases</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Analyze and Record Results</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/boxtesting.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>

<!-- testing automation  -->
<div class="service-odd" id="automationtesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/testing-automation.svg" alt="" class="service-img">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">Testing Automation (CI/CD Integration)</h6>
        <p class="service-description">
          Testing Automation has become an integral part of reducing regression testing time and achieving significant cost savings for every software development process. At Qualibar, we assist you with your business objectives by drafting an automation strategy that lines up with your enterprise goals. Our framework tests the functionality of various API & Cloud-based apps, microservices and service-oriented architectures to cater to all your business needs.
        </p>
        <h6 class="service-subtitle">Our Automation Testing Process:</h6>
        <ul class="key-services odd-keyservices row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Analyze and Define Scope</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Test Script Development</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Framework Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Result Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Test Data Creation</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-testauto-analysis.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Support and Maintenance</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
